<template>
    <div>
        <div v-if="loading" class="pd-y-15">
            <spinner-component :classes="'spinner-border'" :loading="loading"/>
        </div>

        <div v-if="error" class="error">
			{{ error }}
        </div>

        <div v-if="message">
            <div class="mail-content-header">
                <div class="media">
                    <div class="avatar avatar-sm">
                        <img :src="message.customer_details.avatar" class="rounded-circle" alt="">
                    </div>
                    <div class="media-body mg-l-10">
                        <h6 class="mg-b-2 tx-13">{{ message.customer_details.name }}</h6>
                        <span class="d-block tx-11 tx-color-03">{{ messageDate }}</span>
                    </div>
                </div>
                <nav class="nav nav-icon-only mg-l-auto">
                    <router-link class="nav-link" :to="{ name: 'messages.inbox' }">Go Back</router-link>
                </nav>
            </div>
            <div class="mail-content-body ps">
                <div class="pd-20 pd-lg-25 pd-xl-30">
                    <h5 class="mg-b-30">
                        <p class="tx-color-03 tx-11 mg-b-0">{{ message.subject }}</p>
                        {{ message.topic }}
                    </h5>

                    <p class="tx-color-03">{{ message.message }}</p>
                    
                    <p v-if="message.type === 'receive'">
                        <span>Kind regards,</span><br>
                        <strong>IC Group</strong>
                    </p>
                </div>
                <div class="pd-20 pd-lg-25 pd-xl-30 pd-t-0-f">
                    <comments-component :comments="message.comments"/>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
	import PerfectScrollbar from "perfect-scrollbar";
	import "../../../../../js/scripts/mail";

	export default {
		mounted() {
			if (window.matchMedia("(max-width: 768px)").matches) {
				$("body").addClass("mail-content-show");
			}
		},
		data() {
			return {
				loading: false,
				message: null,
				error: null
			};
		},
		created() {
			this.fetchMessage();
		},
		computed: {
			messageDate() {
				return moment(
					this.message.created_at,
					"YYYY-MM-DD hh:mm:ss"
				).calendar(null, {
					sameDay: "[Today] [at] LT",
					lastDay: "[Yesterday] [at] LT",
					lastWeek: "[Last] dddd [at] LT",
					sameElse: "MMMM D YYYY [at] LT"
				});
			}
		},
		watch: {
			$route: "fetchMessage"
		},
		methods: {
			fetchMessage() {
				this.loading = true;
				this.message = this.error = null;

				axios
					.get(`/api/messages/${this.$route.params.id}`)
					.then(response => {
						const message = response.data.data.messages;

						if (!_.isEmpty(message)) {
							this.message = message;
						}
					})
					.catch(error => {
						this.error = error.toString();
					})
					.finally(() => {
						new PerfectScrollbar(".mail-content-body", {
							suppressScrollX: true
						});

						this.loading = false;
					});
			}
		}
	};
</script>